import { SET_GASTEN_VERBRUIK, ADD_GASTEN_VERBRUIK, GASTEN_VERBRUIK_ERROR, SET_GAST_VERBRUIK, SET_VERBRUIK, SET_GAST, SET_GASTS, SET_TIP, SET_TIPS, SET_GASTEN_PROFIEL, GET_GASTEN_PROFIEL, SET_ARTIKELEN, SET_ARTIKEL, ARTIKEL_ERROR, DELETE_GASTEN_VERBRUIK, SET_ACTIVITY_LOGS, ACTIVITY_LOGS_LOADING, ACTIVITY_LOGS_ERROR, SET_ALL_ACTIVITY_LOGS, ALL_ACTIVITY_LOGS_LOADING, ALL_ACTIVITY_LOGS_ERROR, SET_ELECTRICITY_DATA, ELECTRICITY_DATA_LOADING, ELECTRICITY_DATA_ERROR, SET_KAMPEERPLAATSEN, KAMPEERPLAATSEN_LOADING, KAMPEERPLAATSEN_ERROR, SET_REPORTS, REPORTS_LOADING, REPORTS_ERROR, REPORT_SAVED } from "./actions";
export default function gastenverbruik(
  state = {
    gastenverbruik: [],
    gasten: [],
    gast: {},
    gastverbruik: {},
    verbruik: [],
    tips:[],
    tip:{},
    error: "",
    gastenprofielen: [],
    gastenprofiel: {},
    artikelen: [],
    artikel: {},
    artikelError: "",
    activityLogs: [],
    activityLogsLoading: false,
    activityLogsError: null,
    allActivityLogs: [],
    allActivityLogsLoading: false,
    allActivityLogsError: null,
    electricityData: null,
    electricityDataLoading: false,
    electricityDataError: null,
    kampeerplaatsen: [],
    kampeerplaatsenLoading: false,
    kampeerplaatsenError: null,
    reports: [],
    reportsLoading: false,
    reportsError: null
  },
  action = {}
) {
  switch (action.type) {
    case SET_GASTEN_VERBRUIK:
      return { ...state, gastenverbruik: action.results };
    case ADD_GASTEN_VERBRUIK:
      return { ...state, gast: action.results };
    case GASTEN_VERBRUIK_ERROR:
      return { ...state, error: action.error };
    case SET_GAST_VERBRUIK:
      return { ...state, gastverbruik: action.results };
    case SET_VERBRUIK:
      return { ...state, verbruik: action.results };
    case SET_GAST:
      return { ...state, gast: action.results };
    case SET_GASTS:
      return { ...state, gasten: action.results };
    case SET_TIP:
      return { ...state, tip: action.results };
    case SET_TIPS:
      return { ...state, tips: action.results };
    case SET_GASTEN_PROFIEL:
      return { ...state, gastenprofiel: action.results };
    case GET_GASTEN_PROFIEL:
      return { ...state, gastenprofielen: action.results };
    case SET_ARTIKELEN:
      return { ...state, artikelen: action.results };
    case SET_ARTIKEL:
      return { ...state, artikel: action.results };
    case ARTIKEL_ERROR:
      return { ...state, artikelError: action.payload };
    case DELETE_GASTEN_VERBRUIK:
      return { 
        ...state, 
        gastenverbruik: state.gastenverbruik.filter(item => item._id !== action.id),
        gastverbruik: state.gastverbruik._id === action.id ? {} : state.gastverbruik
      };
    case SET_ACTIVITY_LOGS:
      return { ...state, activityLogs: action.logs };
    case ACTIVITY_LOGS_LOADING:
      return { ...state, activityLogsLoading: action.loading };
    case ACTIVITY_LOGS_ERROR:
      return { ...state, activityLogsError: action.error };
    case SET_ALL_ACTIVITY_LOGS:
      return { ...state, allActivityLogs: action.logs };
    case ALL_ACTIVITY_LOGS_LOADING:
      return { ...state, allActivityLogsLoading: action.loading };
    case ALL_ACTIVITY_LOGS_ERROR:
      return { ...state, allActivityLogsError: action.error };
    case SET_ELECTRICITY_DATA:
      return { ...state, electricityData: action.data };
    case ELECTRICITY_DATA_LOADING:
      return { ...state, electricityDataLoading: action.loading };
    case ELECTRICITY_DATA_ERROR:
      return { ...state, electricityDataError: action.error };
    case SET_KAMPEERPLAATSEN:
      return { ...state, kampeerplaatsen: action.kampeerplaatsen };
    case KAMPEERPLAATSEN_LOADING:
      return { ...state, kampeerplaatsenLoading: action.loading };
    case KAMPEERPLAATSEN_ERROR:
      return { ...state, kampeerplaatsenError: action.error };
    case SET_REPORTS:
      return { ...state, reports: action.reports };
    case REPORTS_LOADING:
      return { ...state, reportsLoading: action.loading };
    case REPORTS_ERROR:
      return { ...state, reportsError: action.error };
    case REPORT_SAVED:
      return { ...state, reports: [action.report, ...state.reports] };

    default:
      return state;
  }
}
